/**
 * Authentication Store
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@/services/erpnextAuth';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isLoading: false,

      setUser: (user) => set({ user }),
      setLoading: (loading) => set({ isLoading: loading }),
      clearUser: () => set({ user: null }),
    }),
    {
      name: 'arkodd-auth',
    }
  )
);
